import { render } from "./Footer.vue?vue&type=template&id=2da0ea6d&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=2da0ea6d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2da0ea6d"

export default script